// Contact is an admin-only Sub Profile component, so it will live in admin-app.

import { Section } from "swing-components";

import { CopyableContactRow } from "~components/Molecules/CopyableContactRow";
import { translate } from "~utils";

type ContactProps = {
  phone?: string;
  email?: string;
};
export function Contact(props: ContactProps) {
  const { phone, email } = props;
  return (
    <Section title={translate("LABEL_CONTACT")}>
      {phone && (
        <div
          css={{
            display: "flex",
            gap: "var(--spacing-base)",
            marginBottom: "var(--spacing-md)",
            marginTop: "var(--spacing-md)",
          }}
        >
          <CopyableContactRow
            ariaLabel={translate("SUB_INFO_CARD_COPY_PHONE_LABEL")}
            icon="Phone"
            displayValue={phone}
            copyValue={phone}
          />
        </div>
      )}
      {email && (
        <div css={{ display: "flex", gap: "var(--spacing-base)" }}>
          <CopyableContactRow
            ariaLabel={translate("SUB_INFO_CARD_COPY_PHONE_LABEL")}
            icon="Mail"
            displayValue={email}
            copyValue={email}
          />
        </div>
      )}
    </Section>
  );
}
